/* Same-origin fetch wrapper. The session is an httpOnly cookie, so there is no
   token to attach - but nothing here may go cross-origin without also giving
   the cookie SameSite=None and teaching FastAPI about CORS. */

export async function api<T = unknown>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const response = await fetch(path, {
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  if (!response.ok) {
    let detail = `HTTP ${response.status}`;
    try {
      detail = ((await response.json()) as { detail?: string }).detail || detail;
    } catch {
      /* an error page that isn't JSON - the status is all we get */
    }
    throw new Error(detail);
  }
  return response.status === 204 ? (null as T) : ((await response.json()) as T);
}

export function errorText(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}
